import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconLocation } from '@redteclab/icons'

import { Link } from 'base-ui'

import { useGetExperiment } from '../../../../experiments/hooks'
import { EXPERIMENT_NAME_PDP_DELIVERY_OPTIONS } from '../../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../../experiments/model/EXPERIMENT_VARIATION'
import { useNowGeneralContext } from '../../../../now'
import { productAccessorIsSaeOffer } from '../../../model/productAccessor/productAccessorIsSaeOffer'
import { useProductPageContext } from '../../productPageContext'
import { useProductPrices } from '../hooks/useProductPrices'
import { ProductBuyBoxNowDeliveryInfo } from '../ProductBuyBoxNowDeliveryInfo'

import { ProductBuyBoxDeliveryInfo } from './ProductBuyBoxDeliveryInfo'
import { ProductBuyBoxStockStatus } from './ProductBuyBoxStockStatus'

export const ProductBuyBoxDeliveryStatusInfoBox: FC = () => {
  const {
    currentOffer,
    currentPrescriptionType,
    nowDetails,
    offerId,
    product,
  } = useProductPageContext()
  const { nowGeneralData, productPageNowDialogControls } =
    useNowGeneralContext()
  const zip = nowGeneralData.zipSupportInfo?.zip

  const { isOfferMirakl } = useProductPrices({
    currentPrescriptionType,
    offerId,
    product,
  })

  const isMarketplace = currentOffer
    ? !productAccessorIsSaeOffer(currentOffer)
    : false

  const pdpDeliveryOptions = useGetExperiment(
    EXPERIMENT_NAME_PDP_DELIVERY_OPTIONS,
  )

  return (
    <>
      <div
        className={clsx(
          'flex',
          nowDetails.nowCustomerJourneyEnabled && !isOfferMirakl
            ? 'flex-col gap-1'
            : 'w-full flex-row justify-between',
        )}
      >
        {pdpDeliveryOptions.isEnabled &&
        !isMarketplace &&
        pdpDeliveryOptions.variant !== EXPERIMENT_VARIATION.DEFAULT ? (
          <ProductBuyBoxNowDeliveryInfo />
        ) : (
          <>
            <ProductBuyBoxStockStatus />
            <ProductBuyBoxDeliveryInfo />
          </>
        )}
      </div>
      {nowDetails.nowCustomerJourneyEnabled && !isOfferMirakl ? (
        <Link
          className="flex flex-row items-center gap-1 no-underline"
          onClick={productPageNowDialogControls.handleOpen}
          slots={{ root: 'button' }}
        >
          <IconLocation aria-hidden className="size-6" />
          <span className="sr-only">
            <FormattedMessage id="now.link.location.aria-label" />
          </span>
          <span className="font-medium text-dark-primary-max">
            {zip ?? <FormattedMessage id="now.link.zip" />}
          </span>
        </Link>
      ) : null}
    </>
  )
}
